module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-select-dropdown__item",
    class: {
      'selected': _vm.itemSelected,
      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
        'hover': _vm.hover
    },
    on: {
      "mouseenter": _vm.hoverItem,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectOptionClick($event)
      }
    }
  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6036eb8a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/select/src/option.vue
// module id = 1070
// module chunks = 2